((Drupal, once) => {
  Drupal.behaviors.mobileChampionshipNav = {
    attach: (context) => {
      once('mobileChampionshipNav', 'html', context).forEach(() => {
        const pageBody = document.querySelector('body');
        const menuView = document.querySelector(
          '.view-display-id-championship_mobile_nav',
        );
        const navFlexWrapper = menuView.querySelector(
          '.mobile-championship-nav--flex-wrapper',
        );
        const dropupButton = navFlexWrapper.querySelector(
          'button.dropdown-toggle',
        );

        // If page is a championship site, we need to set up the navbar differently
        // to maintain styles and structure. To do this we prepend a blank div,
        // and append the first subpage link found in the list.
        if (pageBody.classList.contains('node--type-championship-site')) {
          // Prepend a blank div to maintain structure for flex styles.
          const blankDiv = document.createElement('div');
          navFlexWrapper.prepend(blankDiv);

          // Grab and append first subpage in the list (1 indexed)
          const firstSubpageRow = menuView.querySelector('.views-row-1');
          const firstSubpageLink = firstSubpageRow
            .querySelector('a')
            .cloneNode(true);
          firstSubpageLink.classList.add('next-championship-subpage');
          // Append to flex container.
          navFlexWrapper.append(firstSubpageLink);
        } else {
          const currentPageLink = menuView.querySelector(
            `a[href = "${window.location.pathname}"]`,
          );

          if (currentPageLink) {
            // Hide current page in dropdown and add its title to the dropdown toggle.
            const currentPageRow = currentPageLink.closest('.views-row');
            const currentPageTitle = currentPageRow.querySelector('a').text;
            currentPageRow.classList.add('d-none');
            dropupButton.innerHTML = currentPageTitle;

            // Grab and clone previous subpage link and display outside dropdown.
            const previousPageRow = currentPageRow.previousElementSibling;
            const previousPageLink = previousPageRow
              .querySelector('a')
              .cloneNode(true);
            previousPageLink.classList.add('previous-championship-subpage');
            // Prepend previous page row link
            navFlexWrapper.prepend(previousPageLink);

            // Grab and clone next subpage link and display outside dropdown.
            const nextPageRow = currentPageRow.nextElementSibling;
            if (nextPageRow != null) {
              const nextPageLink = nextPageRow
                .querySelector('a')
                .cloneNode(true);
              nextPageLink.classList.add('next-championship-subpage');
              // Append next page row link
              navFlexWrapper.append(nextPageLink);
            }
          }
        }
      });
    },
  };
})(Drupal, once);
